export default __webpack_public_path__ + "static/c09-0e2d0f1559459846a725cc46724fdebe.png";